import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/tabsWithDotsStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { CaptionBold, HeadingMBold } from 'components/Typography/Typography';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import CustomCircularProgress from 'components/CustomCircularProgress/CustomCircularProgress';
import { translate } from 'components/Translation';
import Lock from '@material-ui/icons/Lock';

// @ts-ignore
const useStyles = makeStyles(styles);

export interface ITab {
	name: string;
	content: React.ReactElement;
	title?: string;
	disabled?: boolean;
}

interface ITabsWithDotsProps {
	tabs: ITab[];
	activeTab: number;
	setActiveTab: React.Dispatch<React.SetStateAction<number>>;
	contentClasses?: string;
	footer?: React.ReactElement;
	loading?: boolean;
	wrapperClass?: string;
	isNewDashBoardEnabled?: boolean;
}

const TabsWithDots = ({
	tabs,
	activeTab,
	setActiveTab,
	contentClasses,
	footer,
	loading = false,
	wrapperClass,
	isNewDashBoardEnabled,
}: ITabsWithDotsProps) => {
	const classes = useStyles();

	const setTab = (index: number, disabled?: boolean) => {
		if (index <= activeTab && !disabled) {
			setActiveTab(index);
		}
	};

	return (
		<div className={wrapperClass}>
			{!isNewDashBoardEnabled && (
				<div className={classes.scrollWrapper}>
					<div className={classes.menuWrapper} style={{ minWidth: (tabs.length - 1) * 106 + 72 }}>
						{tabs.map((tab, index) => (
							<div key={index} className={classes.withLine}>
								<div
									className={classNames({
										[classes.dotWrapper]: true,
										[classes.activeDotWrapper]: index <= activeTab && !tab.disabled,
									})}
									onClick={() => setTab(index, tab.disabled)}
								>
									<ConditionalRender
										show={!!tab.disabled}
										onTrue={() => (
											<Lock
												className={classNames({
													[classes.lockIcon]: true,
													[classes.lockIconActive]: index <= activeTab,
												})}
											/>
										)}
										onFalse={() => (
											<div
												className={classNames({
													[classes.dot]: true,
													[classes.activeDot]: index <= activeTab,
													[classes.currentActiveDot]:
														index !== tabs.length - 1 && index == activeTab,
												})}
											/>
										)}
									/>
									<div
										className={classNames({
											[classes.activePTag]: index <= activeTab,
											[classes.text]: true,
										})}
									>
										<CaptionBold color="disabled-light" disableMargin>
											{tab.name}
										</CaptionBold>
									</div>
								</div>
								{index < tabs.length - 1 && (
									<div
										className={classNames({
											[classes.line]: true,
											[classes.activeLine]: index <= activeTab - 1,
										})}
									/>
								)}
							</div>
						))}
					</div>
				</div>
			)}
			<div className={contentClasses}>
				<ConditionalRender
					show={!!tabs[activeTab].title && !isNewDashBoardEnabled}
					onTrue={() => <HeadingMBold>{tabs[activeTab].title}</HeadingMBold>}
				/>
				{tabs[activeTab].content}
				<ConditionalRender show={!!footer} onTrue={() => footer} />
			</div>
			<ConditionalRender
				show={!!loading}
				onTrue={() => (
					<div className={classes.loadingWrapper}>
						<CustomCircularProgress text={translate('loading.it.can.take.a.while')} loading transparent />
					</div>
				)}
			/>
		</div>
	);
};

export default TabsWithDots;
